export const PROVINCE_MAPPING = [
  {
    name: 'An Giang',
    id: 1,
  },
  {
    name: 'Bà Rịa - Vũng Tàu',
    id: 2,
  },
  {
    name: 'Bắc Giang',
    id: 3,
  },
  {
    name: 'Bắc Kạn',
    id: 4,
  },
  {
    name: 'Bạc Liêu',
    id: 5,
  },
  {
    name: 'Bắc Ninh',
    id: 6,
  },
  {
    name: 'Bến Tre',
    id: 7,
  },
  {
    name: 'Bình Định',
    id: 9,
  },
  {
    name: 'Bình Dương',
    id: 8,
  },
  {
    name: 'Bình Phước',
    id: 10,
  },
  {
    name: 'Bình Thuận',
    id: 11,
  },
  {
    name: 'Cà Mau',
    id: 12,
  },
  {
    name: 'Cần Thơ',
    id: 14,
  },
  {
    name: 'Cao Bằng',
    id: 13,
  },
  {
    name: 'Đà Nẵng',
    id: 15,
  },
  {
    name: 'Đắk Lắk',
    id: 16,
  },
  {
    name: 'Đắk Nông',
    id: 17,
  },
  {
    name: 'Điện Biên',
    id: 18,
  },
  {
    name: 'Đồng Nai',
    id: 19,
  },
  {
    name: 'Đồng Tháp',
    id: 20,
  },
  {
    name: 'Gia Lai',
    id: 21,
  },
  {
    name: 'Hà Giang',
    id: 22,
  },
  {
    name: 'Hà Nam',
    id: 23,
  },
  {
    name: 'Hà Nội',
    id: 28,
  },
  {
    name: 'Hà Tĩnh',
    id: 25,
  },
  {
    name: 'Hải Dương',
    id: 26,
  },
  {
    name: 'Hải Phòng',
    id: 27,
  },
  {
    name: 'Hậu Giang',
    id: 29,
  },
  {
    name: 'Hồ Chí Minh',
    id: 30,
  },
  {
    name: 'Hòa Bình',
    id: 31,
  },
  {
    name: 'Hưng Yên',
    id: 32,
  },
  {
    name: 'Khánh Hòa',
    id: 33,
  },
  {
    name: 'Kiên Giang',
    id: 34,
  },
  {
    name: 'Kon Tum',
    id: 35,
  },
  {
    name: 'Lai Châu',
    id: 36,
  },
  {
    name: 'Lâm Đồng',
    id: 37,
  },
  {
    name: 'Lạng Sơn',
    id: 38,
  },
  {
    name: 'Lào Cai',
    id: 39,
  },
  {
    name: 'Long An',
    id: 40,
  },
  {
    name: 'Nam Định',
    id: 41,
  },
  {
    name: 'Nghệ An',
    id: 42,
  },
  {
    name: 'Ninh Bình',
    id: 43,
  },
  {
    name: 'Ninh Thuận',
    id: 44,
  },
  {
    name: 'Phú Thọ',
    id: 45,
  },
  {
    name: 'Phú Yên',
    id: 46,
  },
  {
    name: 'Quảng Bình',
    id: 47,
  },
  {
    name: 'Quảng Nam',
    id: 48,
  },
  {
    name: 'Quảng Ngãi',
    id: 49,
  },
  {
    name: 'Quảng Ninh',
    id: 50,
  },
  {
    name: 'Quảng Trị',
    id: 51,
  },
  {
    name: 'Sóc Trăng',
    id: 52,
  },
  {
    name: 'Sơn La',
    id: 53,
  },
  {
    name: 'Tây Ninh',
    id: 54,
  },
  {
    name: 'Thái Bình',
    id: 55,
  },
  {
    name: 'Thái Nguyên',
    id: 56,
  },
  {
    name: 'Thanh Hóa',
    id: 57,
  },
  {
    name: 'Thừa Thiên Huế',
    id: 58,
  },
  {
    name: 'Tiền Giang',
    id: 59,
  },
  {
    name: 'Trà Vinh',
    id: 60,
  },
  {
    name: 'Tuyên Quang',
    id: 61,
  },
  {
    name: 'Vĩnh Long',
    id: 62,
  },
  {
    name: 'Vĩnh Phúc',
    id: 63,
  },
  {
    name: 'Yên Bái',
    id: 64,
  },
]
